<template>
  <div :class="$style.dropdownFilterContainer">
    <div :class="$style.dropdownContainer">
      <DropdownOperators
        v-if="hasOperators"
        v-model:operator="internalOperator"
        :filter="filter"
        :version="dsComponentDetails.version"
      />
      <DropdownMatchTypes
        v-if="hasMatchType"
        v-model:match-type="internalMatchType"
        :filter="filter"
        :version="dsComponentDetails.version"
      />
    </div>
    <div class="sb-dropdown-chain-item">
      <sb-dropdown-search
        v-if="dsComponentDetails.version === VersionOptions.LEGACY"
        v-bind="filter.props"
        v-model:value="internalValue"
        :options="filteredOptions"
        @search="handleSearch($event, filter)"
      >
        <template #selection="scope">
          <sb-selected-dropdown-search-option
            :value="mapSelections(scope?.selection)"
          />
        </template>
        <template #default="scope">
          <sb-dropdown-option>
            <span v-if="!scope?.option?.secondaryDisplayName">{{ scope?.option?.displayName }}</span>
            <div
              v-else
              class="secondary-display-name-option"
            >
              <span>{{ scope?.option?.displayName }}</span>
              <small>{{ scope.option?.secondaryDisplayName }}</small>
            </div>
          </sb-dropdown-option>
        </template>
      </sb-dropdown-search>
      <sb-auto-complete
        v-else
        v-bind="filter.props"
        v-model="internalValue"
        :suggestions="filteredOptions"
        option-label="displayName"
        multiple
        fluid
        @complete="handleSearch($event, filter)"
      />
    </div>
  </div>
</template>
<script>
import SbSelectedDropdownSearchOption from '@src/components/Dropdown/SbSelectedDropdownSearchOption.vue';
import SbDropdownOption from '@src/components/Dropdown/SbDropdownOption.vue';
import SbDropdownSearch from '@src/components/Dropdown/SbDropdownSearch.vue';
import DropdownOperators from '@src/components/Filter/components/collapsable/DropdownOperators.vue';
import SbAutoComplete from '@src/components/AutoComplete/SbAutoComplete.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import DropdownMatchTypes from '@src/components/Filter/components/collapsable/DropdownMatchTypes.vue';

export default {
  name: 'DropdownSearch',
  components: {
    SbDropdownSearch,
    SbSelectedDropdownSearchOption,
    SbDropdownOption,
    DropdownOperators,
    SbAutoComplete,
    DropdownMatchTypes,
  },
  mixins: [versionedComponentsMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    filterValue: {
      type: Object,
      default: () => { },
    },
  },
  emits: ['update:filter-value'],
  data: () => {
    return {
      filteredOptions: [],
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.filterValue?.value || [];
      },
      set(value) {
        this.$emit('update:filter-value', {
          operator: this.internalOperator,
          value,
          matchType: this.internalMatchType,
        });
      },
    },
    optionsList() {
      return this.filter.options;
    },
    hasOperators() {
      return this.filter && this.filter.operators?.length;
    },
    hasMatchType() {
      return this.filter && this.filter.matchTypes?.length && this.dsComponentDetails.version === 'next';
    },
    internalOperator: {
      get() {
        return this.filterValue?.operator ?? this.filter.defaultOperator;
      },
      set(value) {
        this.$emit('update:filter-value', {
          operator: value,
          value: this.filterValue?.value,
          ...(this.internalMatchType && { matchType: this.internalMatchType }),
        });
      },
    },
    internalMatchType: {
      get() {
        return this.filterValue?.matchType ?? this.filter.defaultMatchType;
      },
      set(value) {
        this.$emit('update:filter-value', {
          operator: this.internalOperator,
          value: this.filterValue?.value,
          matchType: value,
        });
      },
    },
  },
  methods: {
    mapSelections(selections = []) {
      return selections.map((s) => s.displayName).join(', ');
    },
    async handleSearch(event) {
      const searchTerm = this.dsComponentDetails.version === this.VersionOptions.LEGACY
        ? event.searchTerm : event.query;

      if (this.filter.search) {
        this.filteredOptions = await this.filter.search(searchTerm);
      } else if (searchTerm.length > 0) {
        this.filteredOptions = this.optionsList.filter(
          (o) => o.displayName.toLowerCase().includes(searchTerm.toLowerCase()),
        );
      } else {
        this.filteredOptions = this.optionsList;
      }
    },
  },
};
</script>

<style lang="scss" module>
@use '@src/components/Filter/style/sb-dropdown-filter.module.scss';
</style>
